import APIService from "@/services/APIService.js"; 

export default {
    getUnitizacoes(includeExpiredRecords) {
        return APIService.apiCall().get(`/unitizacoesObras/getUnitizacoes/${includeExpiredRecords}`);
    },
    getUnitizacao(id) {
        return APIService.apiCall().get(`/unitizacoesObras/getUnitizacao/${id}`);
    },
    executarUnitizacao(id) {
        return APIService.apiCall().get(`/unitizacoesObras/executar/${id}`);
    },
    excluirUnitizacao(id) {
        return APIService.apiCall().get(`/unitizacoesObras/excluir/${id}`);
    },
    salvarUnitizacao(postData, id) {
        return APIService.apiCall().post(`/unitizacoesObras/salvar/${id}`,JSON.stringify(postData))
    },
    download(id, config = {}) {
        return APIService.apiCall().get(`/unitizacoesObras/baixarPlanilha/${id}`, { responseType: "blob", ...config });
    },
    andamento(id) {
        return APIService.apiCall().get(`/unitizacoesObras/andamento/${id}`);
    }
};